var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.className,attrs:{"fill":"none","height":_vm.height,"viewBox":"0 0 24 24","width":_vm.width,"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M21 12H3M3 12L11.5 3.5M3 12L11.5 20.5","stroke":"black","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }